<template>
    <div class="panel ">
        <div class="panel-heading green-heading">
          <div
              class="code-comment-tooltip"
              data-toggle="tooltip"
              data-placement="bottom"
              :title="'Markiere Codezeilen und schreibe einfach los oder klick auf ein Plus, um einen Kommentar zu schreiben. Wenn du über ' +
               'gelb markierte Codezeilen hoverst, werden die entsprechenden Kommentare angezeigt.'">
            <h4 class="panel-title"><strong>Code-Kommentare </strong>
              <i
                  class="dev-circle-info"
              ></i>
            </h4>
          </div>
        </div>
        <div class="panel-body" style="max-height: 60vh; overflow-y: auto;">
            <div class="row">
                <div class="col-xs-12">
                    <div v-if="!loaded && !error" class="loading-indicator-wrapper">
                        <code-comment-loading-indicator v-for="index in commentsCount"  :key="index" :height="60"></code-comment-loading-indicator>
                    </div>
                    <div v-if="error" class="error-message">
                      <img class="icon" src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1643639005/eh-platform/icons/smashicons_website_elements_website-error-28-icon-cartoony.svg">
                      <span>Es ist ein <strong>Fehler</strong> beim Laden der Kommentare aufgetreten
                        :(</span>
                    </div>
                    <div v-if="loaded && !error && codeComments.length === 0">
                        <p>Noch <strong>keine</strong> Kommentare zum Code vorhanden!
                        </p>
                    </div>
                    <div v-if="loaded && !error && codeComments.length > 0">
                        <div :id="comment.id" class="rating code-comment animated fadeIn"
                             :class="{'activeCodeComment': highlightedComment && comment.id === highlightedComment.id, 'selected': !selectedCommentForCodeCommentId && comment.id === selectedCodeCommentId}"
                             v-for="comment of codeComments"
                             @click="highlightCodeComment(comment)"
                             @mouseenter="highlightCodeComment(comment)"
                             @mouseleave="removeHighlightCodeComment()"
                             v-bind:key="comment.id">
                            <div class="row" style="margin-bottom: 0.7rem">
                                <div class="col-lg-12">
                                    <router-link class="rating-user"
                                                 target="_blank"
                                                 :to="{ name: 'public-user-profile', params: { userId: comment.user.publicId }}">
                                        <img style="float: left; margin-right: 1rem;"
                                             class="img-responsive judgement-image"
                                             :src="getJudgementImage(comment.judgement)">
                                        <div class="profileName">
                                            <strong>{{comment.user.userName}}</strong>
                                        </div>
                                    </router-link>
                                    <div class="date">{{ getNiceTime(comment.timeCreated) }}</div>
                                    <div class="user-rating">&bdquo;{{comment.message}}&rdquo;
                                    </div>
                                    <div class="comments-count">
                                        <i v-if="comment.comments.length === 0" class="fa fa-comment-o"/>
                                        <i v-if="comment.comments.length === 1" class="fa fa-comment"/>
                                        <i v-if="comment.comments.length > 1" class="fa fa-comments"/>
                                        <span>{{ comment.comments.length }} Kommentar{{ comment.comments.length !== 1 ? 'e' : '' }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12" style="margin-top: 1rem;">
                                    <comment-for-code-comment-form
                                            @textUnfocused="commentForCodeCommentTextUnfocused()"
                                            @successful="updateCodeComments"
                                            @textFocused="commentForCodeCommentTextFocused(comment)"
                                            :code-comment-id="comment.id">
                                    </comment-for-code-comment-form>
                                    <div v-for="commentForCodeComment of comment.comments"
                                         :id="commentForCodeComment.id"
                                         v-bind:key="commentForCodeComment.id">
                                        <div class="commentForCodeComment" :class="{'new-added': commentForCodeComment.newAdded, 'selected': commentForCodeComment.id === selectedCommentForCodeCommentId}">
                                            <router-link class="rating-user"
                                                         target="_blank"
                                                         :to="{ name: 'public-user-profile', params: { userId: comment.user.publicId }}">
                                                <i class="fa fa-comment"/>
                                                <strong class="codeCommentForCodeCommentName">{{getUserName(commentForCodeComment.publicUserId)}}</strong>
                                            </router-link>
                                            <div class="date">{{ getNiceTime(commentForCodeComment.timeCreated) }}</div>
                                            <p class="commentForCodeCommentText">
                                                {{commentForCodeComment.text}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CommentForCodeCommentForm from "./CommentForCodeCommentForm";
    import {eventBus, services} from "../../main";
    import {CODE_COMMENT_JUDGEMENT_CHOICES} from "../../const";
    import CodeCommentLoadingIndicator from "./CodeCommentLoadingIndicator";
    import moment from "moment";

    export default {
        name: "CodeCommentsComponent",
        components: {CommentForCodeCommentForm, CodeCommentLoadingIndicator},
        props: {
            solutionId: {type: String, required: true}
        },
        data() {
            return {
                codeCommentsRequest: services.rankTheCodeService.getCodeComments(this.solutionId),
                publicUserProfilesRequest: {loaded: false, error: null},
                publicUserIdMap: new Map(),
                commentForCommentInputFieldSelected: false,
                highlightedComment: null,
                commentsCount: 0,
                userProfileRequest: {loaded: false, error: null},
                selectedCodeCommentId: null,
                selectedCommentForCodeCommentId: null,
            };
        },
        created() {
          this.userProfileRequest = services.userService.getUserProfile();
          this.selectedCodeCommentId = this.$route.query.codeCommentId || null;
          this.selectedCommentForCodeCommentId = this.$route.query.commentForCodeCommentId || null;
          let query = Object.assign({}, this.$route.query);
          delete query.codeCommentId;
          delete query.commentForCodeCommentId;
          // dirty hack to remove query params from url, so we catch the error linking to the same site
          this.$router.replace({query}).catch(()=>{});
        },
        mounted() {
            eventBus.$on("rank-the-code-comments-updated", () => {
                this.reloadCodeComments();
            });
        },
        beforeDestroy() {
            // don't remove 'rank-the-code-comments-updated', because other components still need it
        },
        computed: {
            loaded: function () {
                return this.codeCommentsRequest.loaded && this.publicUserProfilesRequest.loaded && this.userProfileRequest.loaded;
            },
            error: function () {
                return this.codeCommentsRequest.error || this.publicUserProfilesRequest.error || this.userProfileRequest.error;
            },
            codeComments: function () {
                let codeCommentsList = [];
                if (!this.codeCommentsRequest.apiData || !this.publicUserProfilesRequest.loaded || !this.userProfileRequest.loaded) {
                    return codeCommentsList;
                }
                this.createPublicUserIdMap();
                for (let codeComment of this.codeCommentsRequest.apiData) {
                    codeComment.user.userName = this.getUserName(codeComment.user.publicId);
                    codeComment.user.userImage = this.getUserImage(codeComment.user.publicId);
                    for (let commentForCodeComment of codeComment.comments) {
                        commentForCodeComment.userName = this.getUserName(commentForCodeComment.publicUserId);
                        commentForCodeComment.userImage = this.getUserImage(commentForCodeComment.publicUserId);
                    }
                    codeCommentsList.push(codeComment);
                }
                return codeCommentsList;
            },
        },
        methods: {
            getNiceTime(timestamp) {
              moment.locale("de");
              let dateString = moment(timestamp).format("DD.MM.YY");
              if (moment(timestamp).isSame(moment(), "day")) {
                  dateString = moment(timestamp).fromNow();
              }
              return dateString;
            },
            getPublicUserIds() {
                let publicUserIds = [];
                for (let codeComment of this.codeCommentsRequest.apiData) {
                    publicUserIds.push(codeComment.user.publicId);
                    for (let commentForCodeComment of codeComment.comments) {
                        publicUserIds.push(commentForCodeComment.publicUserId);
                    }
                }
                return publicUserIds;
            },
            createPublicUserIdMap() {
                this.publicUserProfilesRequest.apiData.forEach(publicUserData => this.publicUserIdMap.set(publicUserData.publicUserId, {
                    displayName: publicUserData.displayName,
                    profilePicture: publicUserData.profilePicture
                }));
            },
            getUserName(publicUserId) {
                if (!this.publicUserIdMap.has(publicUserId)) {
                    return "Anonymer EntwicklerHeld";
                }
                return this.publicUserIdMap.get(publicUserId)["displayName"];
            },
            getUserImage(publicUserId) {
                if (!this.publicUserIdMap.has(publicUserId)) {
                    return "https://s3.amazonaws.com/s3-cuescience/anonym-user.png";
                }
                return this.publicUserIdMap.get(publicUserId)["profilePicture"];
            },
            getJudgementImage(judgementValue) {
                return CODE_COMMENT_JUDGEMENT_CHOICES.get(judgementValue)["imageUrl"];
            },
            reloadCodeComments() {
                this.commentsCount = this.codeCommentsRequest.apiData ? this.codeCommentsRequest.apiData.length : 0;
                this.commentsCount++;

                this.codeCommentsRequest = {loaded:false,error:null};
                setTimeout(() => {
                  this.codeCommentsRequest = services.rankTheCodeService.getCodeComments(this.solutionId);
                }, 1000);
            },
            updateCodeComments: function(data) {
              const codeCommentId = data.codeCommentId;
              const codeComment = this.codeCommentsRequest.apiData.find((comment) => comment.id === codeCommentId);

              if (codeComment) {
                const commentId = data.commentId;
                const publicUserId = data.publicUserId;
                const text = data.text;
                const userName = this.getUserName(publicUserId);
                const userImage = this.getUserImage(publicUserId);
                codeComment.comments.unshift({
                  "id": commentId,
                  "isYourComment": true,
                  "text": text,
                  "timeCreated": new Date().toISOString(),
                  "publicUserId": publicUserId,
                  "userName": userName,
                  "userImage": userImage,
                  "newAdded": true,
                });
              }
              else {
                this.reloadCodeComments();
              }
              this.$emit("newCommentAdded", 1);
            },
            commentForCodeCommentTextUnfocused() {
                this.commentForCommentInputFieldSelected = false;
                this.removeHighlightCodeComment()
            },
            commentForCodeCommentTextFocused(comment) {
                this.commentForCommentInputFieldSelected = true;
                this.highlightCodeComment(comment.range);
            },
            highlightCodeComment(comment) {
                if (!this.commentForCommentInputFieldSelected) {
                    this.highlightedComment = comment;
                    this.$emit('highlightCodeComment', comment);
                }
            },
            removeHighlightCodeComment() {
                if (!this.commentForCommentInputFieldSelected) {
                    this.highlightedComment = null;
                    this.$emit('unHighlightCodeComment', this.codeComments);
                }
            },
        },
        watch: {
            "codeCommentsRequest.loaded": function () {
                if (this.codeCommentsRequest.loaded && !this.codeCommentsRequest.error) {
                    let publicUserIds = this.getPublicUserIds();
                    this.publicUserProfilesRequest = services.userService.getDataForPublicUserIds(publicUserIds);
                }
            },
            "solutionId": function () {
                this.reloadCodeComments();
            },
            "userProfileRequest.loaded": function () {
              if (!this.userProfileRequest.loaded || this.userProfileRequest.error) {
                return;
              }
              this.publicUserIdMap.set(this.userProfileRequest.user_profile.uuid, {
                displayName: this.userProfileRequest.user_profile.display_name,
                profilePicture: this.userProfileRequest.user_profile.profile_picture
              });
            },
        },
        updated() {
          this.$nextTick(function () {
            let tooltips = $('[data-toggle="tooltip"]');
            tooltips.tooltip('destroy');
            tooltips.tooltip();
          });
          if (this.selectedCodeCommentId) {
            let element = document.getElementById(this.selectedCodeCommentId);
            if (element) {
              let block = 'center';
              const codeComment = this.codeComments.find(codeComment => codeComment.id === this.selectedCodeCommentId);
              if (this.selectedCommentForCodeCommentId) {
                element = document.getElementById(this.selectedCommentForCodeCommentId);
              }
              else if (codeComment.comments.length !== 0) {
                block = 'nearest';
              }
              this.$nextTick(() => {
                element.scrollIntoView({
                  block: block,
                  inline: "nearest"});
              });
            }
          }
        },
    }
</script>

<style scoped>
    .rating {
        margin-bottom: 2.0rem;
    }

    .comments-count {
        margin-top: 0.5rem;
        font-size: smaller;
        cursor: default;
    }

    .rating-user:hover {
        cursor: pointer;
    }

    .rating-user img {
        width: 40px;
    }

    .comments-count,
    .rating-user i {
      margin-right: 0.5rem;
    }

    .rating-user .profileName {
        width: 80%;
    }

    .date {
      font-size: smaller;
      margin-bottom: .5rem;
      color: grey;
    }

    .rating-user strong {
        white-space: -moz-pre-wrap; /* Firefox */
        white-space: -o-pre-wrap; /* Opera */
        white-space: pre-wrap; /* Chrome */
        word-wrap: break-word; /* IE */
    }

    .user-rating {
        padding-left: 0.3rem;
        padding-top: 0.5rem;
    }

    .commentForCodeComment {
        padding: 1rem;
        display: inline-block;
        background-color: #F8FBFECC;
        border-radius: 7px;
        margin-bottom: 1rem;
        margin-left: 1.5rem;
        width: calc(100% - 1.5rem);
    }

    .selected .commentForCodeComment {
      background-color: transparent;
    }

    .commentForCodeComment.selected {
      background-color: #fadccc;
    }

    .rating.code-comment {
        padding: 0.8rem;
        border-radius: 10px;
        border: 2px solid var(--panel-background);
        background-color: var(--panel-background);
        transition: border 1s;
    }

    .rating.code-comment.selected {
      background-color: #fff8ef;
    }

    .rating.code-comment.activeCodeComment {
        border-left: 2px solid #08AB99;
    }

    @media (max-width: 576px) {
        .commentForCodeComment {
            margin-left: 0;
        }
    }

    .commentForCodeCommentText {
        padding-top: 0.3rem;
    }

    .commentForCodeCommentText {
        padding-left: 0.3rem;
    }

    .codeCommentForCodeCommentName {
        white-space: -moz-pre-wrap; /* Firefox */
        white-space: -o-pre-wrap; /* Opera */
        white-space: pre-wrap; /* Chrome */
        word-wrap: break-word; /* IE */
    }

    .error-message {
      padding: 1.5rem;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .icon {
      height: 3rem;
      margin-right: 2rem;
    }
    .code-comment-tooltip {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .commentForCodeComment.new-added {
    background-image:none !important;
         -o-animation: fadeIt 1s ease-out;
            animation: fadeIt 1s ease-out;
    }

    @-o-keyframes fadeIt {
      0%   { background-color: transparent; opacity: 0; }
      50%  { background-color: #00bf8f; opacity: 1; }
      100% { background-color: #F8FBFECC; }
    }
    @keyframes fadeIt {
      0%   { background-color: transparent; opacity: 0; }
      50%  { background-color: #00bf8f; opacity: 1; }
      100% { background-color: #F8FBFECC; }
    }
</style>
